import createVueComponent from '../createVueComponent';

const Minus = createVueComponent('MinusIcon', [
  ['line', { x1: '5', y1: '12', x2: '19', y2: '12' }],
]);

export default Minus;
